import React, { useState, useEffect, useCallback } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import cn from "classnames";
import Typography from "@/components/Typography";

import ChatEntityItem from "../ChatEntityItem";

import styles from "./styles.module.scss";

const ANIMATION_TIMEOUT = 200;

export default function ChatEntity({ onReply, data, conversationId }) {
    const [index, setIndex] = useState(0);
    const [direction, setDirection] = useState("up");
    const [itemCount, setItemCount] = useState(data.length);

    const animationClassNames = {
        enter: styles[`item--enter`],
        enterActive: styles[`item--enter-active`],
        exit: styles[`item--exit`],
        exitActive: styles[`item--exit-active`],
    };

    const handleSwitchTop = useCallback(() => {
        setDirection("up");
        if (data.length > index + 1) {
            setIndex(index + 1);
        } else {
            setIndex(0);
        }
    }, [data.length, index]);

    const handleSwitchDown = useCallback(() => {
        setDirection("down");
        if (index === 0) {
            setIndex(data.length - 1);
        } else {
            setIndex(index - 1);
        }
    }, [data.length, index]);

    useEffect(() => {
        if (!data[index]) {
            handleSwitchTop();
        }
    }, [data, index, handleSwitchTop]);

    useEffect(() => {
        if (data.length > itemCount) {
            setItemCount(data.length);
            setIndex(data.length - 1);
        }
    }, [data.length, itemCount]);

    return (
        <div className={styles.item__wrapper}>
            <div className={styles.item__list}>
                <TransitionGroup
                    className={cn(
                        styles.item__inside,
                        direction === "up" && styles["item__inside--reverse"],
                    )}
                >
                    <CSSTransition
                        classNames={animationClassNames}
                        timeout={ANIMATION_TIMEOUT}
                        className={styles.item}
                        key={index}
                    >
                        <div>
                            {data[index] && (
                                <ChatEntityItem
                                    onReply={onReply}
                                    item={data[index]}
                                    conversationId={conversationId}
                                />
                            )}
                        </div>
                    </CSSTransition>
                </TransitionGroup>
                {data.length > 1 && (
                    <div className={styles.item__buttons}>
                        <button
                            type="button"
                            onClick={handleSwitchTop}
                            className={`${styles.item__button} ${styles["item__button--top"]}`}
                        />
                        <Typography align="center" weight="bold" component="span">
                            {data.length}
                        </Typography>
                        <button
                            type="button"
                            onClick={handleSwitchDown}
                            className={`${styles.item__button} ${styles["item__button--bottom"]}`}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
